export const LABELS = {
    nosCasamos: "¡Nos casamos!",
    initialPhrase: "Lo que empezó como una amistad creció con el tiempo... se volvió complicidad, amor, y ahora, un para siempre.",
    secondPhrase: "Con la promesa más sincera de elegirnos cada día.",
    thirdPhrase: " Tenemos el agrado de invitarte a",
    nuestra: "Nuestra",
    boda: "Boda",
    ceremonia: "Ceremonia y Recepción",
    verUbicacion: "Ver ubicación",
    codigoVestimenta: "Código de vestimenta",
    tipoVestimenta: "FORMAL AL AIRE LIBRE",
    evitar: "Evitar colores",
    suPresencia: "¡Su presencia es el mejor regalo para nosotros! Si aún desean obsequiarnos un detalle para nuestra nueva etapa en matrimonio, un sobre cerrado será bienvenido ese día con mucho cariño.",
    cancion: "Agregar una canción",
    nosAcompanas: "¿Nos acompañas?",
    confirmanos: "Por favor confírmanos tu asistencia con un mensajito. ¡Nos haría mucha ilusión saber que vienes!",
    confirmar: "confirmar",
    gracias: "Gracias por acompañarnos en este día tan especial para nosotros.",
    nosAyudasPlaylist: "Nos ayudas con la playlist?",
    regalos: "Regalos"

};
export const EVENT = {
    bride: "Rose",
    groom: "& Paul",
    date: "08 · 20 · 2025",
    dateLetters: "Sábado, 20 de agosto",
    hour: "4:00 PM",
    address: "123 Devon St. Kearny, New Jersey",
    linkRSPV: "https://forms.gle/MyyMdJCcCp9WRboX7",
    linkAddress: "https://www.google.com/maps/place/123+Devon+St,+Kearny,+NJ+07032",
    linkWhatsapp: "https://wa.me/19735835202?text=Hola,%20quiero%20confirmar%20mi%20asistencia%20a%20su%20boda%20el%2013%20de%20septiembre%20🥰"
};

const BASE = process.env.PUBLIC_URL;
export const MEDIA = {
    anillos: `${BASE}/roseandpaul/anillos.png`,
    bola: `${BASE}/roseandpaul/bola.png`,
    main: `${BASE}/roseandpaul/main.jpg`,
    m_c1: `${BASE}/roseandpaul/m_c1.jpg`,
    m_c2: `${BASE}/roseandpaul/m_c2.jpg`,
    m_c4: `${BASE}/roseandpaul/m_c4.jpg`,
    m_c5: `${BASE}/roseandpaul/mc5.jpg`,
    m_c6: `${BASE}/roseandpaul/m_c6.jpg`,
    m_c7: `${BASE}/roseandpaul/m_c7.jpg`,
    m_c8: `${BASE}/roseandpaul/mc_8.jpg`,
    sobre_optimized: `${BASE}/roseandpaul/sobre_optimized.webp`,
    song: `${BASE}/roseandpaul/suertetenerte2.m4a`,
}